import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

window.addEventListener("error", (event) => {
  const msg = event.message?.toLowerCase() || "";
  if (
    msg.includes("removechild") ||
    msg.includes("insertbefore") ||
    msg.includes("not a child of this node")
  ) {
    event.preventDefault();
    event.stopPropagation();
    console.warn("[DOM] Browser extension conflict suppressed:", event.message);
  }
});

document.title = "OpenBox by ShopJimmy";

createRoot(document.getElementById("root")!).render(<App />);
